import Vue from 'vue'
import Vuex from 'vuex'
import { authentication } from './modules/authentication'
import { operators } from './modules/operators'
import { categories } from './modules/categories'
import { cards } from './modules/cards'
import { floors } from './modules/floors'
import { beacons } from './modules/beacons'
import { settings } from './modules/settings'
import { units } from './modules/units'
import { users } from './modules/users'
import { news } from './modules/news'
import { questions } from './modules/questions'
import { all_locations } from './modules/all_locations'
import { analysis } from './modules/analysis'
import { calendars } from './modules/calendars'
import { common } from './modules/common'
import { sanids } from './modules/sanids'
import { geofences } from './modules/geofences'
import { notifications } from './modules/notifications'
import { notification_settings } from './modules/notification_settings'

Vue.use(Vuex)

const modulesResetName = [
  'categories',
  'cards',
  'floors',
  'beacons',
  'settings',
  'users',
  'news',
  'questions',
  'all_locations',
  'analysis',
  'calendars',
  'sanids',
  'geofences',
  'notifications',
  'notification_settings',
]

export default new Vuex.Store({
  actions: {
    resetAllModulesState({ commit }, modulesNamePlayload) {
      let modulesName = modulesResetName
      if (modulesNamePlayload) {
        modulesName = modulesNamePlayload
      }

      modulesName.forEach(name => {
        commit(`${name}/RESET_STATE`, {}, { root: true })
      })
    },
  },
  modules: {
    authentication,
    operators,
    categories,
    beacons,
    floors,
    cards,
    settings,
    users,
    units,
    news,
    questions,
    all_locations,
    analysis,
    calendars,
    common,
    sanids,
    geofences,
    notifications,
    notification_settings,
  }
})
